import Vue from 'vue';
const b = 'c-contractor-search';
Vue.component('contractor-card', {
  props: {
    contractor: Object,
    showClose: false,
  },

  methods: {
    clickClose: function() {
      this.$emit('click-close');
    },
  },
  template: `
  <div class="${b}__card">
    <div class="${b}__close" v-if="showClose" v-on:click="clickClose"></div>
    <div class="${b}__card-header">
      {{contractor.name}}
    </div>
    <div class="${b}__card-block">
      <p>Adresse</p>
      <p>{{contractor.maps.street_name}} {{contractor.maps.street_number}}</p>
      <p>{{contractor.maps.post_code}} {{contractor.maps.city}}</p>
    </div>
    <div class="${b}__card-block">
      <p>Kontakt</p>
      <p>{{contractor.tel}}</p>
      <p>{{contractor.email}}</p>
      <p><a :href="contractor.link" target="_blank">{{contractor.link}}</a></p>
    </div>
    <a :href="contractor.slug" target="_blank" class="${b}__card-more">ZUM PROFIL</a>
  </div>`,
});


// WEBPACK FOOTER //
// ./scripts/vue-components/contractor-card.js